import http from "./httpService";
// import apiUrl  from ".././config.json";
const apiUrl = require("../config.json").apiUrl;

export const getboattype = () => {
    const apiEndPoint = `${apiUrl}/CheckddlBoatHouse`;
    return http.get(`${apiEndPoint}`);
  };